import { Component } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { UserPlatform } from "@interfaces/IUser";
import { AccountService } from "@services/account.service";
import { CurrentUserService } from "@services/currentUser.service";
import { TranslationService } from "@services/translation.service";
import "./contact-page.component.scss";

@Component({
    selector: "contact-page",
    template: require("./contact-page.component.html")
})
export class ContactPageComponent {
    supportEmail = "support.smarttransport.uk@addsecure.com";

    foundationKbAddress: SafeResourceUrl;

    constructor(
        private readonly currentUserService: CurrentUserService,
        private readonly accountService: AccountService,
        private readonly domSanitizer: DomSanitizer,
        private readonly translationService: TranslationService) {
        if (this.currentUserService.cachedUser.platform == UserPlatform.Foundation) {
            this.foundationKbAddress = this.domSanitizer.bypassSecurityTrustResourceUrl("https://docs.verilocation.com/api-documentation/");
        }


        this.foundationKbAddress = this.domSanitizer.bypassSecurityTrustResourceUrl("https://docs.verilocation.com/api-documentation/");
        this.foundationKbAddress = this.domSanitizer.bypassSecurityTrustResourceUrl("https://github.com/GitbookIO/gitbook");
    }

    emailSupport() {
        var companyName = this.accountService.getAccountDataFromCache().CompanyName;
        let subject = this.translationService.t('ContactPage.SupportEmailSubject', companyName);
        window.open(`mailto:${this.supportEmail}?subject=${subject}`);
    }

    callSupport() {
        window.open(`tel:+443301112636`);
    }

    callSales() {
        window.open(`tel:+443301112636`);
    }

    viewAPIDocs() {
        window.open(`https://docs.verilocation.com/api-documentation/`);
    }

    viewReleaseNotes() {
        window.open(`https://docs.verilocation.com/release-notes/`);
    }
}
